import React, { useState, useEffect } from "react";
import { Link as RouterLink, useParams, useHistory } from "react-router-dom";

// Material UI
import {
  Typography,
  Box,
  Tabs,
  Tab,
  Link,
} from "@material-ui/core";

//design-system
import StatusCourseCard from "../../../design-system/components/Cards/StatusCourseCard/StatusCourseCard.jsx";
import { getSourceBySourceAndCompany } from "../../../design-system/utils/source.js";

// SDK-POINT
import { CourseService, MembershipService, STATUS_COURSES } from "@sdk-point/talisis";

//Shared
import LoaderContent from "../../../shared/components/Loader/LoaderContent.jsx";
import { getSessionCookie } from "../../../shared/utils/Sessions.js";
import { log } from "../../../shared/utils/console.js";
import getConnectionAllies from "../../../shared/components/Allies/AlliesConnect.jsx";
import { validateMembership } from "../../../shared/utils/membershipUtils.js";
import { manuallyAttemptMembershipPayment as attemptMembershipPayment } from "../../../shared/utils/membershipRepurchase.js";
import { SOURCES } from "../../../shared/constants/sources.js";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { applyCart, applyCartProducts } from "../../../redux/actions/cartActions.js";
import { CART } from "../../../routes/paths";

const LABEL_IN_PROCESS = "En progreso";
const LABEL_COMPLETED = "Completados";
const INDEX_TAB_IN_PROGRESS = 0;
const INDEX_TAB_COMPLETADO = 1;

const objectIsEmpty = (obj) => !obj || Object.keys(obj).length === 0;

const alliesFree = [SOURCES['GOOGLE'], SOURCES['HUBSPOT']];

const programService = {
  postPersonEnrollToClass: async () => Promise.resolve(),
};
const changeStatusEnrollmentCourse = () => {};

const EduconCourses = () => {
  const [valueActive, setValueActive] = useState(0);
  const [statusCourse, setStatusCourse] = useState(STATUS_COURSES.IN_PROGRESS);
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userMembership, setUserMembership] = useState(null);
  const [userAddOn, setUserAddOn] = useState(null);
  const [loadingRepurchase, setLoadingRepurchase] = useState(false);
  const { company_id, source_id } = useParams();
  const user = getSessionCookie();
  const history = useHistory();
  const dispatch = useDispatch();
  const { cart } = useSelector((state) => state.cartReducer);

  const courseService = new CourseService(
    process.env.REACT_APP_ENV,
    process.env.REACT_APP_X_API_KEY
  );
  const membershipService = new MembershipService(
    process.env.REACT_APP_ENV,
    process.env.REACT_APP_X_API_KEY
  );

  const pageNumber = 1;
  const pageSize = 30;

  useEffect(() => {
    getCourses();
  }, [statusCourse]);

  useEffect(() => {
    const loadMembership = async () => {
      try {
        const detail = await membershipService.getPersonMembershipDetail(user?.person_id);
        setUserMembership(detail?.userMembership);
        setUserAddOn(detail?.userAddOn);
      } catch (e) {
        log("Error loading membership", e);
      }
    };
    loadMembership();
  }, []);

  const manuallyAttemptMembershipPayment = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    await attemptMembershipPayment({
      userMembership,
      userAddOn,
      cart,
      user,
      dispatchCart: dispatch,
      applyCart,
      applyCartProducts,
      history,
      cartPath: CART,
      setLoadingRepurchase,
    });
  };

  const getCourses = async () => {
    try {
      setLoading(() => true);
      setCourses(() => []);
      let response = [];
      if (company_id) {
        response = await courseService.getCouresEduconByPersonIdAndCompanyId(
          user.person_id,
          company_id,
          statusCourse,
          pageNumber,
          pageSize
        );
      }
      if (source_id) {
        response = await courseService.getCouresEduconByPersonIdAndSourceId(
          user.person_id,
          source_id,
          statusCourse,
          pageNumber,
          pageSize
        );
      }
      setCourses(() => response);
    } catch (e) {
      log("Error get Courses", e);
    } finally {
      setLoading(() => false);
    }
  };

  const handleChangeTab = (event, newTabIndex) => {
    setValueActive(() => newTabIndex);
    if (newTabIndex === INDEX_TAB_IN_PROGRESS) {
      setStatusCourse(() => STATUS_COURSES.IN_PROGRESS);
    }
    if (newTabIndex === INDEX_TAB_COMPLETADO) {
      setStatusCourse(() => STATUS_COURSES.COMPLETED);
    }
  };

  const handleClickGoToCourse = (course) => async () => {
    const route =
      window.location.protocol +
      "//" +
      window.location.host +
      "/redireccionando/" +
      course.source_id;
    let win = window.open(route, "_blank");
    goToCourse(win, course);
  };

  const handleClickRegisterToCourse = (course) => async () => {
    if (!objectIsEmpty(user)) {
      try {
        const route =
          window.location.protocol +
          "//" +
          window.location.host +
          "/redireccionando/" +
          course.source_id;
        const win = window.open(route, "_blank");
        const body = {
          course_id: course.course_id,
          source_id: course.source_id,
          company_id: course.company_id,
          class_id: course.third_party_id,
        };

        try {
          await programService.postPersonEnrollToClass(user.person_id, body);
          changeStatusEnrollmentCourse(course.course_id);
          goToCourse(win, course);
        } catch (err) {}
      } catch (err) {
        log(err);
      }
    }
  };

  const goToCourse = async (win, course) => {
        try {
            const body = {
                person_id: user?.person_id,
                email: user?.email,
                ou: user?.ou,
                course_url: course.course_url,
                source_id: course.source_id,
                course_url_neo: course.course_url_neo,
                course_id: course.course_id,
                company_id: course.company_id
            }

            var urlRespuesta = await getConnectionAllies(body);

            setTimeout(() => {
                win.focus();
                win.location.replace(urlRespuesta);
            }, 3000);
        } catch(error) {
            log(error);
        }
    };

  return (
    <Box>
      <Box display="flex">
        <i className="ri-arrow-left-s-line text-orange-300"></i>
        <Link component={RouterLink} to="/cursos">
          <Typography
            variant="v2"
            className="text-orange-300"
            style={{ marginLeft: "10px" }}
          >
            Volver a mi Clases{" "}
          </Typography>
        </Link>
      </Box>
      <Tabs
        variant="scrollable"
        scrollButtons="auto"
        value={valueActive}
        onChange={handleChangeTab}
        aria-label="scrollable auto tabs example"
        indicatorColor="primary"
      >
        <Tab label={LABEL_IN_PROCESS} />
        <Tab label={LABEL_COMPLETED} />
      </Tabs>
      <Box>
        <LoaderContent loading={loading} minHeight="290px">
          <Box
            display="flex"
            flexWrap="wrap"
            justifyContent="center"
            alignItems="center"
          >
            <Box
              display="flex"
              flexWrap="inherit"
              justifyContent="left"
              alignItems="center"
              maxWidth="1224px"
              gridGap="24px"
            >
              {courses.map((course) => (
                <StatusCourseCard
                  key={course.course_id}
                  courseId={course.course_id}
                  sourceId={course.source_id}
                  userId={parseInt(user.person_id ?? 0)}
                  sourceIdLogo={
                    course.showLogoSource &&
                    getSourceBySourceAndCompany(
                      course.source_id,
                      course.company_id
                    )
                  }
                  enrollmentStatusId={course?.enrollment_status_id || 3}
                  media={{
                    backgroundImage: course.image_url,
                    modalityId: course.modality_id,
                    percentage:
                      statusCourse === STATUS_COURSES.COMPLETED
                        ? 100
                        : course.progress_percentage,
                  }}
                  content={{
                    courseName: course.name ? course.name.slice(0, 87) : "",
                    grade: course.grade,
                  }}
                  isLogged={true}
                  companyId={course.company_id}
                  showDetailButton={
                    (statusCourse === STATUS_COURSES.COMPLETED || validateMembership(userMembership) ? false : true)
                  }
                  onClickGoToCourse={handleClickGoToCourse(course)}
                  onClickGoToDetail={() => history.push(`/course/${course.course_id}`)}
                  approved={statusCourse === STATUS_COURSES.COMPLETED}
                  handleRenovationMembership={(e) => manuallyAttemptMembershipPayment(e)}
                  merbershipIsExpired={
                    alliesFree.includes(course.source_id) ? false : validateMembership(userMembership)
                  }
                />
              ))}
            </Box>
          </Box>
        </LoaderContent>
      </Box>
    </Box>
  );
};

export default EduconCourses;
